import { Heading, magma } from 'react-magma-dom';
import { DocsHeading } from "../../../../src/components/DocsHeading";
import * as React from 'react';
export default {
  Heading,
  magma,
  DocsHeading,
  React
};